import { format, getTime, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

type InputValue = Date | string | number | null | undefined;

export function fDate(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'dd MMM yyyy';

  return date ? format(new Date(date), fm) : '';
}

export function fTime(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'p';

  return date ? format(new Date(date), fm) : '';
}

export function fDateTime(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'dd MMM yyyy p';

  return date ? format(new Date(date), fm) : '';
}

export function fTimestamp(date: InputValue) {
  return date ? getTime(new Date(date)) : '';
}

/**
 * Exact time of a message, to the second: "14:03:27" today, "12 Sep 14:03:27"
 * this year, "12 Sep 2025 14:03:27" otherwise. Debugging a conversation means
 * comparing timestamps across messages, logs and scheduled sends, and "1 day
 * ago" cannot be compared with anything.
 */
export function fPreciseTime(date: InputValue) {
  if (!date) return '';
  const parsed = new Date(date);
  if (isNaN(parsed.getTime())) return '';
  const now = new Date();
  if (parsed.toDateString() === now.toDateString()) return format(parsed, 'HH:mm:ss');
  if (parsed.getFullYear() === now.getFullYear()) return format(parsed, 'dd MMM HH:mm:ss');
  return format(parsed, 'dd MMM yyyy HH:mm:ss');
}

export function fToNow(date: InputValue) {
  if (!date) {
    return '';
  }
  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) {
    return '';
  }
  return formatDistanceToNow(parsedDate, {
    addSuffix: true,
    includeSeconds: false,
  });
}

export function isBetween(inputDate: Date | string | number, startDate: Date, endDate: Date) {
  const date = new Date(inputDate);

  const results =
    new Date(date.toDateString()) >= new Date(startDate.toDateString()) &&
    new Date(date.toDateString()) <= new Date(endDate.toDateString());

  return results;
}

export function isAfter(startDate: Date | null, endDate: Date | null) {
  const results =
    startDate && endDate ? new Date(startDate).getTime() > new Date(endDate).getTime() : false;

  return results;
}
